module.exports = __webpack_public_path__ + "catalog/items/furniture/Bench/Bench.svg";